"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FileUpload = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDropzone = _interopRequireDefault(require("react-dropzone"));

var _Avatar = _interopRequireDefault(require("../Avatar"));

var _Chip = _interopRequireDefault(require("../Chip"));

var _ErrorHandlingFormHelperText = _interopRequireDefault(require("../ErrorHandlingFormHelperText"));

var _FormControl = _interopRequireDefault(require("../FormControl"));

var _FormLabel = _interopRequireDefault(require("../FormLabel"));

var _Loader = _interopRequireDefault(require("../Loader"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("./styles");

var _styles2 = require("@material-ui/core/styles");

var _Grow = _interopRequireDefault(require("@material-ui/core/Grow"));

var _FileHelper = require("../Utilities/FileHelper");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var FileUpload = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(FileUpload, _Component);

  var _super = _createSuper(FileUpload);

  function FileUpload() {
    var _this;

    (0, _classCallCheck2.default)(this, FileUpload);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderAvatar", function (id, file) {
      return !_this.props.disablePreview && file.type.indexOf("image") > -1 ? /*#__PURE__*/_react.default.createElement(_Avatar.default, {
        id: id,
        src: file.preview
      }) : /*#__PURE__*/_react.default.createElement(_Avatar.default, {
        id: id
      }, file.name.slice(file.name.lastIndexOf(".") + 1));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderLoader", function (id) {
      var _this$props = _this.props,
          className = _this$props.className,
          classes = _this$props.classes;
      return /*#__PURE__*/_react.default.createElement(_Loader.default, {
        className: (0, _classnames.default)("prmbl-fileUpload-loader", className, classes.loader),
        id: id
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderChip", function (id, file, onDelete, isProcessing) {
      var _this$props2 = _this.props,
          className = _this$props2.className,
          classes = _this$props2.classes;
      return /*#__PURE__*/_react.default.createElement(_Grow.default, {
        key: id,
        id: id,
        in: true,
        timeout: 500
      }, /*#__PURE__*/_react.default.createElement(_Chip.default, {
        className: (0, _classnames.default)("prmbl-fileUpload-uploadedChip", className, classes.uploadedChip),
        avatar: isProcessing ? _this.renderLoader(id) : _this.renderAvatar(id, file),
        label: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
          className: ((0, _classnames.default)("prmbl-fileUpload-filename"), classes.uploadedChipFilename)
        }, file.name), /*#__PURE__*/_react.default.createElement("span", {
          className: ((0, _classnames.default)("prmbl-fileUpload-filename"), classes.uploadedChipFileSize)
        }, (0, _FileHelper.formatBytes)(file.size))),
        onDelete: onDelete ? function () {
          return onDelete(file, isProcessing);
        } : undefined
      }));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderInputtedFiles", function () {
      var _this$props3 = _this.props,
          id = _this$props3.id,
          filesUploaded = _this$props3.filesUploaded,
          filesProcessing = _this$props3.filesProcessing,
          onDelete = _this$props3.onDelete;
      var results = [];

      if (filesUploaded.length > 0) {
        results.push(filesUploaded.map(function (file, index) {
          var htmlId = "".concat(id, "-fileUploaded-").concat(index);
          return _this.renderChip(htmlId, file, onDelete, false);
        }));
      }

      if (filesProcessing.length > 0) {
        results.push(filesProcessing.map(function (file, index) {
          var htmlId = "".concat(id, "-fileProcessing-").concat(index);
          return _this.renderChip(htmlId, file, onDelete, true);
        }));
      }

      return results;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderInputtedFileComponent", function () {
      var _this$props4 = _this.props,
          filesUploaded = _this$props4.filesUploaded,
          filesProcessing = _this$props4.filesProcessing,
          className = _this$props4.className,
          classes = _this$props4.classes;

      if (filesProcessing.length > 0 || filesUploaded.length > 0) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)("prmbl-fileUpload-uploadedWrapper", className, classes.uploadedWrapper)
        }, _this.renderInputtedFiles());
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderDropzone", function () {
      var _this$props5 = _this.props,
          id = _this$props5.id,
          fileTypes = _this$props5.fileTypes,
          disabled = _this$props5.disabled,
          disablePreview = _this$props5.disablePreview,
          filesProcessing = _this$props5.filesProcessing,
          filesUploaded = _this$props5.filesUploaded,
          maxSize = _this$props5.maxSize,
          minSize = _this$props5.minSize,
          multiple = _this$props5.multiple,
          mustBeImage = _this$props5.mustBeImage,
          onDrop = _this$props5.onDrop,
          className = _this$props5.className,
          classes = _this$props5.classes,
          label = _this$props5.label;
      var accept;

      if (fileTypes) {
        accept = fileTypes;
      } else {
        accept = mustBeImage ? "image/*" : undefined;
      }

      if (!multiple && (filesProcessing.length > 0 || filesUploaded.length > 0)) {
        return;
      } else {
        var inputProps = {
          "aria-describedby": "".concat(id, "-dropzone-inner")
        };

        if (label) {
          inputProps["aria-labelledby"] = "".concat(id, "-label");
        }

        return /*#__PURE__*/_react.default.createElement(_reactDropzone.default, {
          id: id,
          accept: accept,
          disabled: disabled,
          disablePreview: disablePreview,
          multiple: multiple,
          maxSize: maxSize,
          minSize: minSize,
          onDrop: onDrop,
          className: (0, _classnames.default)("prmbl-fileUpload", className, classes.dropzone),
          inputProps: inputProps
        }, _this.renderDropzoneInner);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderDropzoneInner", function (_ref) {
      var getRootProps = _ref.getRootProps,
          getInputProps = _ref.getInputProps,
          isDragActive = _ref.isDragActive,
          isDragAccept = _ref.isDragAccept,
          isDragReject = _ref.isDragReject,
          acceptedFiles = _ref.acceptedFiles;
      var _this$props6 = _this.props,
          classes = _this$props6.classes,
          className = _this$props6.className,
          children = _this$props6.children,
          disabled = _this$props6.disabled,
          id = _this$props6.id,
          dontWrapChildren = _this$props6.dontWrapChildren;

      if (dontWrapChildren) {
        return children;
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        id: "".concat(id, "-dropzone-inner"),
        className: (0, _classnames.default)("prmbl-fileUpload-dropzoneInner", className, classes.dropzoneInner, (0, _defineProperty2.default)({}, classes.dragActive, isDragActive), (0, _defineProperty2.default)({}, classes.dragReject, isDragReject), (0, _defineProperty2.default)({}, classes.dragAccept, isDragAccept), (0, _defineProperty2.default)({}, classes.dropzoneDisabled, disabled))
      }, children);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var _this$props7 = _this.props,
          id = _this$props7.id,
          error = _this$props7.error,
          disabled = _this$props7.disabled,
          errorMessage = _this$props7.errorMessage,
          fullWidth = _this$props7.fullWidth,
          helperText = _this$props7.helperText,
          label = _this$props7.label,
          required = _this$props7.required,
          className = _this$props7.className,
          classes = _this$props7.classes;
      return /*#__PURE__*/_react.default.createElement(_FormControl.default, {
        id: id,
        className: (0, _classnames.default)("prmbl-fileUpload", className, classes.root, (0, _defineProperty2.default)({}, classes.fullWidth, fullWidth)),
        error: error,
        disabled: disabled,
        fullWidth: fullWidth,
        required: required
      }, label && /*#__PURE__*/_react.default.createElement(_FormLabel.default, {
        component: "label",
        id: id
      }, label), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _this.renderDropzone(), /*#__PURE__*/_react.default.createElement(_ErrorHandlingFormHelperText.default, {
        id: id,
        helperText: helperText,
        errorMessage: errorMessage,
        className: (0, _classnames.default)("prmbl-fileUpload-errorText", classes.errorMessage)
      }), _this.renderInputtedFileComponent()));
    });
    return _this;
  }

  return FileUpload;
}(_react.Component);

exports.FileUpload = FileUpload;
(0, _defineProperty2.default)(FileUpload, "propTypes", {
  /**
   * The html id. This must be unique for accessibility.
   */
  id: _propTypes.default.string.isRequired,

  /**
   * The allowed file types to upload. Use both the MIME type and file extension for best results.
   */
  fileTypes: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),

  /**
   * Contents to be displayed within the FileUpload component
   */
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),

  /**
   * @ignore
   *
   * Utilizing this to style up the page don't want to expose this in the style guide.
   * Auto-populated by material-ui withStyles()
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * If `true`, the component will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the preview generation will be disabled.
   */
  disablePreview: _propTypes.default.bool,

  /**
   * 	If `true`, the input will indicate an error. And display the provided errorMessage
   */
  error: _propTypes.default.bool,

  /**
   * The message to display when `error` is `true`.
   */
  errorMessage: _propTypes.default.string,

  /**
   * Adds helper text to the component
   */
  helperText: _propTypes.default.string,

  /**
   * Displays the files that were uploaded in a component
   */
  filesUploaded: _propTypes.default.array,

  /**
   * Displays files as being uploaded
   */
  filesProcessing: _propTypes.default.array,

  /**
   * Contains the files that were rejected in the upload
   */
  filesRejected: _propTypes.default.array,

  /**
   * Makes the input span the entire component's width
   */
  fullWidth: _propTypes.default.bool,

  /**
   * The label to display
   */
  label: _propTypes.default.node,

  /**
   * If `false`, only a single file can be uploaded
   */
  multiple: _propTypes.default.bool,

  /**
   * If set, a limit will be placed on the maximum filesize allowed
   */
  maxSize: _propTypes.default.number,

  /**
   * If set, a limit will be placed on the minimun filesize required for uploading
   */
  minSize: _propTypes.default.number,

  /**
   * If `true`, the file upload component will only accept images
   */
  mustBeImage: _propTypes.default.bool,

  /**
   * Callback called when a file is selected (either drag and dropped or selected from the file browser)
   * Signature: `function(filesUploaded) => void`
   *
   * filesUploaded: All the files that the File Upload component accepted
   */
  onDrop: _propTypes.default.func,

  /**
   * Callback called when a file is deleted from the FileUpload component.
   *
   * Signature: `function(file, isProcessing) => void`
   *
   * file: The file being deleted
   * isProcessing: Indicates that the file is in the filesProcessing prop. Otherwise the file is in the FilesUploaded prop
   */
  onDelete: _propTypes.default.func,

  /**
   * If `true` the label will indicate that the input is required.
   */
  required: _propTypes.default.bool,

  /**
   * @ignore
   *
   * Utilized By:
   * CivicEngage, CP Platform
   */
  className: _propTypes.default.string,

  /**
   * If `true` the dropzone's children won't be wrapped into the dropzone-inner div
   * This useful to have full control of the FileUpload children content
   */
  dontWrapChildren: _propTypes.default.bool
});
(0, _defineProperty2.default)(FileUpload, "defaultProps", {
  filesUploaded: [],
  filesProcessing: [],
  filesRejected: [],
  multiple: true,
  className: "",
  fullWidth: true,
  dontWrapChildren: false
});

var _default = (0, _styles2.withStyles)(_styles.styles)(FileUpload);

exports.default = _default;